import type { ICompanyPlan, ICompanyPlanTaxByMcc } from "@shared/types";
import { ERatePlanReceiptType } from "@payfac/types";

export interface GetCompanyPlanContextArgs {
  sellerCompanyPlans?: ICompanyPlan;
  earlyCompanyPlans?: ICompanyPlan;
  timelineCompanyPlans?: ICompanyPlan;
  receiptType: keyof typeof ERatePlanReceiptType;
  receiptTypeChanged: boolean;
}

export const getCompanyPlanContext = ({
  sellerCompanyPlans,
  earlyCompanyPlans,
  timelineCompanyPlans,
  receiptType,
  receiptTypeChanged,
}: GetCompanyPlanContextArgs): ICompanyPlan | undefined => {
  const byReceiptType = {
    [ERatePlanReceiptType.EARLY]: earlyCompanyPlans,
    [ERatePlanReceiptType.TIMELINE]: timelineCompanyPlans,
  };

  if (receiptTypeChanged || !sellerCompanyPlans) {
    return byReceiptType[receiptType];
  }

  return sellerCompanyPlans;
};

export const getCompanyPlanTaxByMcc = (
  companyPlan: ICompanyPlan | undefined,
  mcc: string,
): ICompanyPlanTaxByMcc | undefined => {
  const key = companyPlan?.tax?.taxConfigsByMcc?.[mcc] ? mcc : "default";
  return companyPlan?.tax?.taxConfigsByMcc?.[key];
};
